import type { Component } from "vue";

import { PHOSPHOR_ICONS } from "./phosphorIcons.generated";

const storedIcons = import.meta.glob<Component>("../../assets/icons/generic/*.svg", {
  eager: true,
  import: "default",
  query: "?component",
});

const iconNameOf = (file: string) => file.replace(/^.*\/icons\/|\.svg$/g, "");

/** Every icon as a component, keyed by `<set>/<name>`. */
export const iconRegistry: ReadonlyMap<string, Component> = new Map<string, Component>([
  ...Object.entries(PHOSPHOR_ICONS),
  ...Object.entries(storedIcons).map(([file, component]) => [iconNameOf(file), component] as const),
]);
